export const getOptionName = (option: { language: any[] }, languageId: number) => {
  const lang = option.language.find((lang) => lang.language_id === languageId)

  if (lang) {
    if (lang.label !== null && lang.label !== undefined && lang.label.length !== 0) {
      return lang.label.trim()
    }
    return lang.name.trim()
  }

  return 'Unknown'
}


